export const ROUTES = {
    root: "/",
    loginKey: "/isv",
    loginEmail: "/isv/login",
    loginLink: "/isv/login-link",
    main: "/isv/manage",
    api: "/isv/api",
} as const;
